import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useParams } from 'react-router-dom';

const FETCH_PORTFOLIO_MODEL_NAME = gql`
  query fetchModelPortfolio($id: ObjectID!) {
    fetchModelPortfolio(input: { modelPortfolioId: $id }) {
      modelPortfolio {
        name
        translatedName { ${TRANSLATED_STRING_FIELDS} }
      }
    }
  }
`;

export function PortfolioModelBreadcrumb() {
  const { data } = useQuery(FETCH_PORTFOLIO_MODEL_NAME, {
    variables: { id: useParams().id },
  });

  // Return just the model name; SmartBreadcrumb wraps it in an org-aware Link
  // using the route pathname, so it owns navigation for this crumb.
  return data
    ? translateBackend(
        data.fetchModelPortfolio?.modelPortfolio.translatedName,
      ) || data.fetchModelPortfolio?.modelPortfolio.name
    : 'Model';
}
